import React from "react";
import ReactDOM from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import App from "./App.tsx";
import { BrowserRouter } from "react-router";
//import { AuthProvider } from "./pages/AuthService";
import "@arcgis/core/assets/esri/themes/light/main.css"; // Adjust the path based on your project structure
import { Notifications } from "@mantine/notifications";
import { Provider } from "react-redux";
import store from "./store/store";

import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <MantineProvider>
        <Notifications position="top-center" />
        <Provider store={store}>
          <App />
        </Provider>
      </MantineProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
